import { useSelector } from 'react-redux';
import { investorSelector } from 'apps/investor/resources/investor/selectors';

export function useInvestorSelector() {
  return useSelector(investorSelector);
}
